import type { EarthlyBranch } from '../types/branches';
import type { Relation } from '../types/relations';
import type { PillarPosition } from '../types/pillars';
import { branchIndex } from '../core/sexagenary';

// 해 pairs (六害):
// 子未, 丑午, 寅巳, 卯辰, 申亥, 酉戌
export const HARM_PAIRS: [number, number][] = [
  [0, 7],  // 子未
  [1, 6],  // 丑午
  [2, 5],  // 寅巳
  [3, 4],  // 卯辰
  [8, 11], // 申亥
  [9, 10], // 酉戌
];

export function findEarthlyHarms(
  branches: { branch: EarthlyBranch; position: PillarPosition }[]
): Relation[] {
  const relations: Relation[] = [];

  for (let i = 0; i < branches.length; i++) {
    for (let j = i + 1; j < branches.length; j++) {
      const a = branchIndex(branches[i].branch);
      const b = branchIndex(branches[j].branch);

      for (const [s1, s2] of HARM_PAIRS) {
        if ((a === s1 && b === s2) || (a === s2 && b === s1)) {
          const [first, second] = a === s1 ? [branches[i], branches[j]] : [branches[j], branches[i]];
          relations.push({
            type: '해',
            pillars: [branches[i].position, branches[j].position],
            branches: [first.branch, second.branch],
            description: `${first.branch}${second.branch}해`,
          });
        }
      }
    }
  }

  return relations;
}
